import script from "./PgmNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmNotice.vue?vue&type=script&setup=true&lang=ts"

import "./PgmNotice.vue?vue&type=style&index=0&id=456e59b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-456e59b3"]])

export default __exports__